(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[59075,2023],{

/***/ 36797:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/websitebuilderselect",
      function () {
        return __webpack_require__(11397);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14302));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: ({ error , isLoading , pastDelay  })=>{
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 16319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadableContext = __webpack_require__(16319);
const { useSyncExternalStore  } =  true ? __webpack_require__(67294) : 0;
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = (ids = [])=>{
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 11397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/layouts/websiteBuilderSelectWrapper.tsx + 1 modules
var websiteBuilderSelectWrapper = __webpack_require__(2023);
// EXTERNAL MODULE: ./src/components/shared/topThree/topThree.module.scss
var topThree_module = __webpack_require__(94190);
var topThree_module_default = /*#__PURE__*/__webpack_require__.n(topThree_module);
// EXTERNAL MODULE: ./src/components/antiviruschoice/svg/badge.tsx
var badge = __webpack_require__(95830);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/svg/rightArrow.tsx
var rightArrow = __webpack_require__(77276);
// EXTERNAL MODULE: ./src/components/shared/affiliateOfferUrl/index.tsx + 1 modules
var affiliateOfferUrl = __webpack_require__(25416);
// EXTERNAL MODULE: ./src/lib/shared/config.ts
var config = __webpack_require__(98218);
;// CONCATENATED MODULE: ./src/components/shared/topThree/index.tsx








const TopThree = ({ title , listing , gradient  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `lg:pb-24 flex flex-col justify-center items-center py-4  ${gradient === "blue" ? (topThree_module_default())["bg-top-gradient-blue"] : (topThree_module_default())["bg-top-gradient-gray"]}`,
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: `${(topThree_module_default()).header} text-center 
                        text-xl md:text-3xl font-bold mt-4 mb-6 lg:mb-12`,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `justify-center items-center w-full flex flex-col lg:flex-row`,
                children: listing && listing.slice(0, 3).map((item, idx)=>{
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: `flex flex-col mb-3 px-10 py-3 lg:px-0 text-xs justify-around w-full items-center ${(topThree_module_default()).offer} h-48 lg:h-52 rounded-md relative lg:w-4/12`,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[150px] h-[60px] relative",
                                children: item?.logo?.fullPath && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: item?.logo?.fullPath,
                                    layout: "fill",
                                    alt: item.title
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-center lg:w-4/6",
                                children: item.description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(affiliateOfferUrl/* default */.Z, {
                                zone: config/* affiliateOfferZones.HOME_PAGE */.ZR.HOME_PAGE,
                                offer: item,
                                target: "_blank",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    className: `rounded-md relative font-bold flex items-center ${(topThree_module_default()).button} px-5 py-3
                                        text-sm h-10`,
                                    children: [
                                        "Get it Now",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(rightArrow/* default */.Z, {
                                            className: "w-4 ml-2"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `hidden ${(topThree_module_default()).badge} ${idx === 0 ? "lg:block" : ""}`,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.Z, {})
                            })
                        ]
                    }, idx);
                })
            })
        ]
    });
};
/* harmony default export */ var topThree = (TopThree);

// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./pages/websitebuilderselect/index.tsx






const FAQ = dynamic_default()(()=>__webpack_require__.e(/* import() */ 85868).then(__webpack_require__.bind(__webpack_require__, 85868)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(85868)
            ]
    }
});
const MainListing = dynamic_default()(()=>__webpack_require__.e(/* import() */ 34260).then(__webpack_require__.bind(__webpack_require__, 34260)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(34260)
            ]
    }
});
var __N_SSP = true;
function Home() {
    const { domain  } = (0,useDomainContext/* useDomainContext */.w)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(websiteBuilderSelectWrapper["default"], {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "text-antivirus-text-black",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(topThree, {
                    title: `The Top 3 Website Builders in ${new Date().getFullYear()}`,
                    listing: domain?.defaultOffers,
                    gradient: "blue"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MainListing, {
                    listing: domain?.defaultOffers,
                    comparison: false
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ, {})
            ]
        })
    });
}


/***/ }),

/***/ 95830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Badge() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "110",
        height: "59",
        viewBox: "0 0 110 59",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                    transform: "translate(24.619)",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "30.381",
                            cy: "30",
                            r: "25",
                            fill: "#FFF"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fill: "#FFC20E",
                            fillRule: "nonzero",
                            d: "M57.28 25.615c-1.3-1.076-1.656-2.869-.946-4.423l.591-1.434c.947-2.152-.236-4.662-2.484-5.26l-1.656-.478c-1.656-.478-2.72-1.912-2.839-3.586V8.88c-.118-2.39-2.247-4.064-4.494-3.706l-1.538.24c-1.656.239-3.312-.479-4.022-2.033l-.71-1.314C38.118.034 35.397-.683 33.505.752l-1.302.956c-1.3.956-3.193.956-4.494 0L26.526.752c-1.893-1.435-4.613-.718-5.678 1.315l-.71 1.314c-.828 1.435-2.484 2.272-4.14 2.033l-1.537-.24C12.213 4.816 9.966 6.49 9.847 8.88l-.118 1.435c-.118 1.673-1.183 3.107-2.839 3.586l-1.42.358c-2.247.598-3.43 3.108-2.483 5.26l.591 1.434c.592 1.554.237 3.347-1.064 4.423L1.33 26.452a3.887 3.887 0 000 5.857l1.183 1.076c1.3 1.076 1.656 2.869.946 4.423l-.592 1.434c-.946 2.152.237 4.662 2.484 5.26l1.42.478c1.656.478 2.72 1.912 2.839 3.586l.118 1.554c.118 2.39 2.248 4.064 4.495 3.706l1.538-.24c1.656-.239 3.312.479 4.021 2.033l.71 1.314c1.065 2.033 3.785 2.75 5.678 1.315l1.301-.956c1.301-.956 3.194-.956 4.495 0l1.183.956c1.892 1.435 4.613.718 5.678-1.315l.71-1.314c.827-1.435 2.483-2.272 4.14-2.033l1.537.24c2.247.358 4.495-1.315 4.613-3.706l.118-1.554c.119-1.674 1.183-3.108 2.84-3.586l1.419-.359c2.247-.597 3.43-3.108 2.484-5.26l-.592-1.434c-.591-1.554-.236-3.347 1.065-4.423l1.183-1.075a3.89 3.89 0 000-5.858l-1.065-.956zm-27.442 23.19c-10.528 0-19.044-8.607-19.044-19.245 0-10.639 8.516-19.245 19.044-19.245 10.527 0 19.044 8.606 19.044 19.245 0 10.638-8.517 19.245-19.044 19.245zM43.559 29.56c0 7.65-6.15 13.866-13.721 13.866-7.57 0-13.721-6.216-13.721-13.866 0-7.65 6.15-13.866 13.72-13.866 7.571 0 13.722 6.215 13.722 13.866z"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#FF4F4F",
                    d: "M108.9 37.21c.473.598.119 1.554-.71 1.554H87.592c-.118-.598-.236-1.195-.473-1.673L87 36.97l.118-.12c2.13-1.793 3.312-4.542 3.312-7.291 0-2.75-1.183-5.499-3.193-7.292l-.119-.12.119-.119c.236-.598.473-1.195.591-1.913h20.48c.829 0 1.302.957.71 1.554l-5.914 7.531a.583.583 0 000 .837l5.796 7.172zM.383 37.21c-.473.598-.119 1.554.71 1.554h20.598c.118-.598.236-1.195.473-1.673l.119-.121-.118-.12c-2.13-1.793-3.312-4.542-3.312-7.291 0-2.75 1.183-5.499 3.193-7.292l.119-.12-.119-.119c-.236-.598-.473-1.195-.591-1.913H.975c-.829 0-1.302.957-.71 1.554L6.179 29.2a.583.583 0 010 .837L.383 37.21z"
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Badge);


/***/ }),

/***/ 2023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ WebsiteBuilderSelectWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/components/websitebuilderselect/header/header.module.scss
var header_module = __webpack_require__(96562);
var header_module_default = /*#__PURE__*/__webpack_require__.n(header_module);
;// CONCATENATED MODULE: ./src/components/websitebuilderselect/header/index.tsx




function Header({ useSecondaryLogo  }) {
    const { domain  } = (0,useDomainContext/* useDomainContext */.w)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: (header_module_default()).header,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "inner max-w-7xl mx-auto px-4 py-4 flex justify-between items-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "logo w-72 lg:w-80",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "/",
                    className: "w-full h-auto mx-auto lg:ml-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: useSecondaryLogo ? domain?.secondaryLogo?.fullPath ?? "./logo.svg" : domain?.logo?.fullPath ?? "./logo.svg",
                        width: "500px",
                        height: "28px",
                        alt: "websitebuilderselect logo"
                    })
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(47041);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./src/components/scripts/schema/index.tsx
var schema = __webpack_require__(28783);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/websiteBuilderSelectWrapper.tsx










const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 2567).then(__webpack_require__.bind(__webpack_require__, 2567)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(2567)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const Popup = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(3294), __webpack_require__.e(66964)]).then(__webpack_require__.bind(__webpack_require__, 66964)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(66964)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 18740).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
function WebsiteBuilderSelectWrapper({ children , useSecondaryLogo  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const { 0: vpnModalActive , 1: setVpnModalActive  } = (0,react.useState)(false);
    const modalActive = vpnModalActive;
    const { active: modalActiveBlogPost  } = modal;
    const handleClose = ()=>{
        closeModal();
    };
    const { domainPopup  } = (0,useDomainContext/* useDomainContext */.w)();
    const handleMouseLeave = ()=>{
        if (document.activeElement?.tagName === "INPUT" || document.activeElement?.tagName === "SELECT") return;
        if (!(0,lib.getCookie)("popup-shown")) {
            setVpnModalActive(true);
            (0,lib.setCookie)("popup-shown", "true");
        }
    };
    const handleModalClose = ()=>{
        setVpnModalActive(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com",
                        crossOrigin: "true"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600;700;800&family=Poppins:ital,wght@0,400;0,500;0,600;0,700;0,900;1,800&display=swap",
                        rel: "stylesheet"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(schema/* default */.Z, {
                        url: "https://Websitebuilderselect.com",
                        name: "Website Builder Select"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onMouseLeave: handleMouseLeave,
                style: {
                    fontFamily: `'Open Sans', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                        useSecondaryLogo: useSecondaryLogo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    domainPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleModalClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalClassName: "h-90vh lg:h-500px rounded",
                        wrapperClassName: "flex items-center",
                        modalStyles: {
                            fontFamily: `'Poppins', sans-serif`
                        },
                        bodyStyles: {
                            height: "100%"
                        },
                        width: 900,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popup, {
                            data: domainPopup
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActiveBlogPost,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: "80vh"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: "Contents",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {})
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 28783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const Schema = ({ url , name  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: `{
                            "@context": "https://schema.org",
                            "@graph": [
                                {
                                    "@type": "WebSite",
                                    "name": "${name}",
                                    "url": "${url}",
                                    "publisher": {
                                        "@type": "Organization",
                                        "name": "${name}",
                                        "url": "${url}",
                                        "logo": {
                                            "@type": "ImageObject",
                                            "url": "${url}/logo.svg"
                                        }
                                    }
                                }
                            ]
                        }`
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Schema);


/***/ }),

/***/ 25416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AffiliateOfferUrl; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/lib/shared/cookies.ts
var cookies = __webpack_require__(76309);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/index.ts + 19 modules
var api = __webpack_require__(21513);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/shared/affiliateOfferUrl/mobileIcon.tsx

const MobileIcon = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        id: "Layer_2",
        viewBox: "0 0 16 22",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "Layer_1-2",
            fill: "#fff",
            d: "M2 12.25V20 2zM2 22c-.55 0-1.02-.2-1.41-.59S0 20.55 0 20V2C0 1.45.2.98.59.59S1.45 0 2 0h10c.55 0 1.02.2 1.41.59S14 1.45 14 2v2h-2V2H2v18h10v-2h2v2c0 .55-.2 1.02-.59 1.41S12.55 22 12 22zm5.71-3.5c.19-.19.29-.43.29-.71s-.1-.52-.29-.71-.43-.29-.71-.29-.52.1-.71.29-.29.43-.29.71.1.52.29.71.43.29.71.29.52-.1.71-.29m3.62-4.65L9.88 12.4c.2-.18.35-.4.46-.64s.16-.5.16-.76-.05-.52-.16-.76-.26-.45-.46-.64l1.45-1.45c.38.38.68.82.88 1.31s.3 1 .3 1.54-.1 1.05-.3 1.54-.49.93-.88 1.31m2.45 2.45-1.4-1.4c.52-.52.92-1.11 1.2-1.78s.43-1.38.43-2.13-.14-1.46-.43-2.13-.68-1.26-1.2-1.78l1.4-1.4q1.08 1.05 1.65 2.43c.57 1.38.58 1.88.58 2.88s-.19 1.96-.58 2.88-.93 1.73-1.65 2.43"
        })
    });
/* harmony default export */ var mobileIcon = (MobileIcon);

// EXTERNAL MODULE: ./src/components/shared/affiliateOfferUrl/style.module.scss
var style_module = __webpack_require__(24027);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./src/components/shared/offerVertical/index.tsx
var offerVertical = __webpack_require__(71466);
;// CONCATENATED MODULE: ./src/components/shared/affiliateOfferUrl/index.tsx








function AffiliateOfferUrl({ className , children , customHref , offer , target , style , zone , template ="default"  }) {
    const { 0: listId , 1: setListId  } = (0,react.useState)(null);
    const { category , locale  } = (0,useDomainContext/* useDomainContext */.w)();
    const clickToCallLabel = (0,offerVertical/* getText */.Q)(category?.config?.clickToCallLabel, locale);
    (0,react.useEffect)(()=>{
        setListId((0,cookies/* getAffiliateListId */.Hf)());
    }, [
        cookies/* getAffiliateListId */.Hf
    ]);
    const queryParams = [];
    if (listId) {
        queryParams.push(`id=${listId}`);
    }
    if (offer?.category?.id) {
        queryParams.push(`categoryId=${offer.category.id.toString()}`);
    }
    if (zone) {
        queryParams.push(`zone=${zone}`);
    }
    let innerLinkContent = children;
    if (customHref) {
        if (template === "default") {
            innerLinkContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: children
            });
        } else {
            innerLinkContent = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (style_module_default()).clickToCallWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (style_module_default()).svgWrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(mobileIcon, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (style_module_default()).textWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (style_module_default()).clickToCall,
                                    children: clickToCallLabel || "Click to Call"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (style_module_default()).phoneNumberClick,
                                    children: children
                                })
                            ]
                        })
                    ]
                })
            });
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        style: style,
        target: target,
        className: className ?? "",
        rel: "noreferrer",
        href: customHref ?? `/offer/${offer?.slug ?? ""}?${queryParams.join("&")}`,
        onClick: ()=>{
            if (customHref) {
                void (0,api/* callEvent */.dr)({
                    event: "Call",
                    phoneNumber: customHref?.split("tel:")[1] ?? ""
                });
            }
        },
        children: innerLinkContent
    });
}


/***/ }),

/***/ 97943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Facebook() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#4780c0",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_32_1514",
                style: {
                    maskType: "alpha"
                },
                width: "18",
                height: "15",
                x: "26",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26.121 10H43.208V25H26.121z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_32_1514)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M33.155 24.318h3.04v-6.881h2.12l.232-2.301h-2.353v-1.31c0-.548.116-.756.7-.756h1.653v-2.388h-2.115c-2.268 0-3.289.898-3.289 2.618v1.841h-1.586v2.329h1.586l.012 6.848z"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Facebook);


/***/ }),

/***/ 22371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Twitter() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#35a9ff",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                style: {
                    maskType: "alpha"
                },
                width: "18",
                height: "15",
                x: "26",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M26.025 10H43.111999999999995V25H26.025z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_32_1513)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M26.01 22.15a10.97 10.97 0 005.135 1.374 11.06 11.06 0 005.201-1.167c1.58-.8 2.878-1.965 3.755-3.369.877-1.403 1.298-2.99 1.217-4.59a6.803 6.803 0 001.779-1.595 7.52 7.52 0 01-2.012.484c.736-.38 1.289-.984 1.553-1.697a7.756 7.756 0 01-2.22.75 3.665 3.665 0 00-1.983-.933c-.76-.111-1.54.002-2.22.32-.68.32-1.22.826-1.537 1.442a2.725 2.725 0 00-.218 1.966 11.02 11.02 0 01-3.997-.927 9.796 9.796 0 01-3.218-2.277 2.746 2.746 0 00-.38 2.234c.203.76.727 1.424 1.467 1.856a3.872 3.872 0 01-1.553-.381c-.01.715.265 1.41.777 1.966s1.228.939 2.026 1.081a4.064 4.064 0 01-1.553.055 3.1 3.1 0 001.24 1.525 3.804 3.804 0 002.022.602 7.394 7.394 0 01-2.492 1.114 7.931 7.931 0 01-2.79.168z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_32_1513",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H17.048V12.164H0z",
                        transform: "translate(26.025 11.364)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Twitter);


/***/ }),

/***/ 43808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Pinterest() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "69",
        height: "35",
        fill: "none",
        viewBox: "0 0 69 35",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "69",
                height: "35",
                fill: "#e60023",
                rx: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "mask0_32_1516",
                style: {
                    maskType: "alpha"
                },
                width: "19",
                height: "15",
                x: "25",
                y: "10",
                maskUnits: "userSpaceOnUse",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#D9D9D9",
                    d: "M25.93 10H43.016999999999996V25H25.93z"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                mask: "url(#mask0_32_1516)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    fill: "#fff",
                    d: "M30.756 18.573a.327.327 0 00.382-.078.262.262 0 00.056-.117c.037-.14.129-.486.172-.631.043-.145.037-.263-.123-.436a2.15 2.15 0 01-.573-1.541c-.007-.505.1-1.005.314-1.47.214-.466.53-.887.929-1.239a4.177 4.177 0 011.392-.806 4.492 4.492 0 011.631-.244c2.33 0 3.607 1.29 3.607 3.01 0 2.262-1.104 4.172-2.75 4.172a1.46 1.46 0 01-.613-.103 1.331 1.331 0 01-.494-.343 1.168 1.168 0 01-.27-.509 1.1 1.1 0 01.014-.564c.26-.994.765-2.066.765-2.792.02-.15.005-.3-.045-.444a1.03 1.03 0 00-.244-.388 1.162 1.162 0 00-.4-.26 1.265 1.265 0 00-.483-.087c-.924 0-1.67.866-1.67 2.028-.006.428.088.853.277 1.245l-1.116 4.273a8.05 8.05 0 000 2.982c.004.02.014.038.03.053a.12.12 0 00.055.03.13.13 0 00.064 0 .12.12 0 00.055-.032 8.308 8.308 0 001.566-2.57c.104-.351.616-2.161.616-2.161.233.312.549.566.918.738.37.171.782.256 1.197.245 2.787 0 4.673-2.301 4.673-5.384 0-2.324-2.176-4.468-5.48-4.468-4.12 0-6.166 2.675-6.166 4.903-.056 1.34.505 2.542 1.714 2.988z"
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Pinterest);


/***/ }),

/***/ 8281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Mobile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/oneElement/index.tsx
var oneElement = __webpack_require__(36895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/share/styles.module.scss
var styles_module = __webpack_require__(48378);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/shared/blogPost/sideWidget/mobile/share/Share.tsx



const Share = ({ shareList  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: shareList?.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: `cursor-pointer  ${(styles_module_default())[el.name]}`,
                onClick: ()=>{
                    window.open(el.link, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");
                    return false;
                },
                children: el.icon
            }, index))
    });
};
/* harmony default export */ var share_Share = (Share);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/Facebook.tsx
var Facebook = __webpack_require__(97943);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/Twitter.tsx
var Twitter = __webpack_require__(22371);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/icons/pinterest.tsx
var pinterest = __webpack_require__(43808);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx









function Mobile() {
    const { asPath  } = (0,router.useRouter)();
    const { blogPost , domain  } = (0,useDomainContext/* useDomainContext */.w)();
    const shareList = [
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook/* default */.Z, {}),
            link: `https://www.facebook.com/sharer/sharer.php?u=https://${domain.name}${asPath}`,
            name: "facebook"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter/* default */.Z, {}),
            link: `https://twitter.com/share?url=https://${domain.name}${asPath}`,
            name: "twitter"
        },
        {
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(pinterest/* default */.Z, {}),
            link: `http://pinterest.com/pin/create/button/?url=https://${domain.name}${asPath}`,
            name: "pinterest"
        }, 
    ];
    const myList = [
        {
            title: "Contents",
            slug: "contents",
            content: (0,sharedUtils/* getMainTitlesNavigationFromBody */._H)(blogPost?.model.body)
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `   px-5 py-10  max-h-[80vh] flex flex-col justify-between `,
        children: [
            myList?.map((el, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(oneElement/* default */.Z, {
                    content: el.content
                }, index)),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: `mt-4 text-sm font-bold`,
                        children: "Share"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `flex  gap-2 mt-3 justify-center  `,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(share_Share, {
                            shareList: shareList
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 36895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OneElement; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25086);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useModalContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67379);



function OneElement({ content  }) {
    const { setModal  } = (0,_hooks_useModalContext__WEBPACK_IMPORTED_MODULE_1__/* .useModal */ .d)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (content?.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().linksList)}      `,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "text-lg mt-8 mb-5 hidden lg:block ",
                    children: "Contents"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "max-h-[300px] overflow-y-auto",
                    children: content?.map((el, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: `
                                ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().bulletedListItem)} pl-5    
                                     pb-5  `,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: el?.link ?? "#",
                                dangerouslySetInnerHTML: {
                                    __html: el?.title
                                },
                                onClick: ()=>setModal({
                                        active: false,
                                        content: undefined
                                    }),
                                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().linkColor)}   block  cursor-pointer text-sm `
                            })
                        }, index))
                })
            ]
        })
    });
}


/***/ }),

/***/ 71466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ getText; },
/* harmony export */   "Z": function() { return /* binding */ OfferVertical; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(81331);
/* harmony import */ var _styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75094);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76877);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25416);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88737);







const getText = (text, locale)=>{
    return text?.[locale] ?? text?.["en"] ?? "";
};
function OfferVertical({ offer , zone , displayLinkAndPhoneNumber , customStyle , template ="default"  }) {
    const phoneNumber = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .getPhoneNumber */ .ly)(offer);
    const { domain , category , locale  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_4__/* .useDomainContext */ .w)();
    const callToActionTitle = getText(category?.config?.offerVerticalCallToActionTitle, locale);
    const callToActionSubTitle = getText(category?.config?.offerVerticalCallToActionSubTitle, locale);
    const buttonFallbackText = getText(category?.config?.offerVerticalButtonFallbackText, locale);
    const freeEvaluationNote = getText(category?.config?.offerVerticalFreeEvaluationNote, locale);
    const phoneNumberMessage = offer?.attributes.phoneNumberMessage ? offer?.attributes.phoneNumberMessage : offer?.hiddenAttributes.phoneNumberMessage ? offer?.hiddenAttributes.phoneNumberMessage : "";
    const outerSectionStyle = {
        "--buttonBackgroundColor": `${customStyle?.buttonBgColor ?? (_styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().autumnGlory)}`
    };
    const clickToCallBorder = typeof domain.config?.clickToCallBorder === "string" ? domain.config.clickToCallBorder : undefined;
    const clickToCallBtnBackground = typeof domain.config?.clickToCallBtnBackground === "string" ? domain.config.clickToCallBtnBackground : undefined;
    const clickToCallBtnForground = typeof domain.config?.clickToCallBtnForground === "string" ? domain.config.clickToCallBtnForground : undefined;
    const clickToCallBtnShadow = typeof domain.config?.clickToCallBtnShadow === "string" ? `rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, ${domain.config.clickToCallBtnShadow} 0px 10px 15px -3px, ${domain.config.clickToCallBtnShadow} 0px 4px 6px -4px ` : undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container)}  relative  mb-[30px] px-4 py-4   ${customStyle?.wrapperStyle ?? ""}`,
        style: outerSectionStyle,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex flex-col flex-wrap items-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: `w-40 mb-4 flex justify-center ${customStyle?.fixedHeight ? "h-20" : ""}`,
                    style: {
                        borderColor: (_styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_5___default().offerBorderColor)
                    },
                    children: offer.logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: offer.logo.fullPath,
                        alt: offer.title
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().title),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        style: {
                                            fontSize: "24px",
                                            fontWeight: "700",
                                            lineHeight: 1.2
                                        },
                                        dangerouslySetInnerHTML: {
                                            __html: phoneNumberMessage || callToActionTitle || "Call Now & Discuss Options!"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().secondTitle),
                                    children: callToActionSubTitle || "Review offers and coverage eligibility instantly."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "order-3 flex flex-col mt-2 w-auto",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    zone: zone,
                                    template: template,
                                    className: `${!displayLinkAndPhoneNumber ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().link) : ""} ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().linkPageBuilderStyle)} ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btnStyle)} flex justify-center rounded-5 text-center px-[10px] py-[10px] text-[15px]`,
                                    offer: offer,
                                    customHref: phoneNumber ? `tel:${phoneNumber ?? ""}` : undefined,
                                    target: "_blank",
                                    style: {
                                        borderRadius: "12px",
                                        border: clickToCallBorder,
                                        background: clickToCallBtnBackground,
                                        color: clickToCallBtnForground,
                                        boxShadow: clickToCallBtnShadow
                                    },
                                    children: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .formatPhoneNumber */ .un)(phoneNumber) || buttonFallbackText || "Let's Go"
                                }),
                                displayLinkAndPhoneNumber && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    zone: zone,
                                    className: `text-left lg:text-center py-3 rounded-lg ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_6___default().letGoStyle)}`,
                                    offer: offer,
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: buttonFallbackText || "Let's Go"
                                    })
                                })
                            ]
                        }),
                        (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .formatPhoneNumber */ .un)(phoneNumber) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                fontSize: "12px",
                                color: "#666",
                                textAlign: "center",
                                marginTop: "15px"
                            },
                            children: freeEvaluationNote || "Free Evaluation • No Obligation"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 77276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function RightArrow({ fill , className  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: className,
        enableBackground: "new 0 0 512 512",
        viewBox: "0 0 492.004 492.004",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: fill ?? "#fff",
            d: "M484.14 226.886L306.46 49.202c-5.072-5.072-11.832-7.856-19.04-7.856-7.216 0-13.972 2.788-19.044 7.856l-16.132 16.136c-5.068 5.064-7.86 11.828-7.86 19.04 0 7.208 2.792 14.2 7.86 19.264L355.9 207.526H26.58C11.732 207.526 0 219.15 0 234.002v22.812c0 14.852 11.732 27.648 26.58 27.648h330.496L252.248 388.926c-5.068 5.072-7.86 11.652-7.86 18.864 0 7.204 2.792 13.88 7.86 18.948l16.132 16.084c5.072 5.072 11.828 7.836 19.044 7.836 7.208 0 13.968-2.8 19.04-7.872l177.68-177.68c5.084-5.088 7.88-11.88 7.86-19.1.016-7.244-2.776-14.04-7.864-19.12z",
            "data-original": "#000000"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (RightArrow);


/***/ }),

/***/ 24027:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"clickToCallWrapper":"style_clickToCallWrapper__VwAdQ","textWrapper":"style_textWrapper__4UGtd","svgWrapper":"style_svgWrapper__hIySB","clickToCall":"style_clickToCall__9Mqb6","phoneNumberClick":"style_phoneNumberClick__xFVNS"};

/***/ }),

/***/ 48378:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"facebook":"styles_facebook__EYfOu","twitter":"styles_twitter__47r59","pintrest":"styles_pintrest__w6OTr"};

/***/ }),

/***/ 25086:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"linkColor":"style_linkColor__aZ9m3","linksList":"style_linksList__xLuOw","bulletedListItem":"style_bulletedListItem__H1JoX"};

/***/ }),

/***/ 76877:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__wOf18","title":"style_title__cWvij","linkPageBuilderStyle":"style_linkPageBuilderStyle__CqdI2","letGoStyle":"style_letGoStyle__5KJJo","link":"style_link__LGb3m","secondTitle":"style_secondTitle__6rLsc","btnStyle":"style_btnStyle__6X7g_"};

/***/ }),

/***/ 94190:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"topThree_button__DKLTi","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","header":"topThree_header__Y0HaF","offer":"topThree_offer__pWyQz","badge":"topThree_badge__R7wNp","bg-top-gradient-blue":"topThree_bg-top-gradient-blue___PoHK","bg-top-gradient-gray":"topThree_bg-top-gradient-gray__fpBa5"};

/***/ }),

/***/ 96562:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81331:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"goGoGreen":"#008a7b","green":"#5bc1a4","bankVault":"#747474","autumnGlory":"#3ea636","offerBorderColor":"#e4e7eb"};

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90638)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3294,49774,92888,40179], function() { return __webpack_exec__(36797); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);